import { Outlet } from 'react-router-dom'

export const Layout = () => <Outlet />
